/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityMalwareData } from './MonitEntityMalwareData';
import {
    MonitEntityMalwareDataFromJSON,
    MonitEntityMalwareDataFromJSONTyped,
    MonitEntityMalwareDataToJSON,
} from './MonitEntityMalwareData';

/**
 * 
 * @export
 * @interface MonitEntityMalwareAggResponse
 */
export interface MonitEntityMalwareAggResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitEntityMalwareAggResponse
     */
    assets?: number;
    /**
     * 
     * @type {MonitEntityMalwareData}
     * @memberof MonitEntityMalwareAggResponse
     */
    malicious?: MonitEntityMalwareData;
    /**
     * 
     * @type {MonitEntityMalwareData}
     * @memberof MonitEntityMalwareAggResponse
     */
    spam?: MonitEntityMalwareData;
}

/**
 * Check if a given object implements the MonitEntityMalwareAggResponse interface.
 */
export function instanceOfMonitEntityMalwareAggResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityMalwareAggResponseFromJSON(json: any): MonitEntityMalwareAggResponse {
    return MonitEntityMalwareAggResponseFromJSONTyped(json, false);
}

export function MonitEntityMalwareAggResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityMalwareAggResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assets': !exists(json, 'assets') ? undefined : json['assets'],
        'malicious': !exists(json, 'malicious') ? undefined : MonitEntityMalwareDataFromJSON(json['malicious']),
        'spam': !exists(json, 'spam') ? undefined : MonitEntityMalwareDataFromJSON(json['spam']),
    };
}

export function MonitEntityMalwareAggResponseToJSON(value?: MonitEntityMalwareAggResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assets': value.assets,
        'malicious': MonitEntityMalwareDataToJSON(value.malicious),
        'spam': MonitEntityMalwareDataToJSON(value.spam),
    };
}

